interface IActivityRecord {
  timestamp: string;
  activityStatus: number;
  posture: number;
}

export const getActivityStatusPosCode = (activityStatus: number, posture: number): number => {
    // activityStatusが2（活動状態の時）は他の姿勢より優先して活動状態であることを示す
  if (activityStatus === 2) {
        // 活動状態は姿勢で定義されていない番号を使う
    // 7: 活動状態かつ寝ている状態 8: 活動状態かつ立っている状態
    return [0, 1, 2].includes(posture) ? 8 : 7;
  }
  return posture;
};

export const createActivityStatusHeatmapBar = <T extends IActivityRecord>(
  data: T[] | undefined | null
): [number, number, number][] => {
  if (!data || !data.length) return [];

  return data.map((v) => [Date.parse(v.timestamp), 0, getActivityStatusPosCode(v.activityStatus, v.posture)]);
};
